import React from "react";
import { APICall } from '../Services/APICall';
import { GetUserInfo } from "../Services/GetUserInfo";
import { PostDataAPI } from '../Services/APIService';
import { v4 as uuidv4 } from 'uuid';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
    switch (action.type) {
        case "LOGIN_SUCCESS":
            return {
                ...state,
                isAuthenticated: true
            };
        case "SIGN_OUT_SUCCESS":
            return {
                ...state,
                isAuthenticated: false
            };
        case "SET_LOGIN_USER": {
            return {
                ...state,
                currentUser: action.payload
            };
        }
        case "SET_LOGOUT_USER": {
            return {
                ...state,
                currentUser: null
            };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

const INITIAL_STATE = {
    currentUser: null,
    isAuthenticated: !!sessionStorage.getItem("auth_token")
};

function UserProvider({ children }) {

    var [state, dispatch] = React.useReducer(userReducer, INITIAL_STATE);

    return (
        <UserStateContext.Provider value={state}>
            <UserDispatchContext.Provider value={dispatch}>
                {children}
            </UserDispatchContext.Provider>
        </UserStateContext.Provider>
    );
}

function useUserState() {
    var context = React.useContext(UserStateContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within a User");
    }
    return context;
}

function useUserDispatch() {
    var context = React.useContext(UserDispatchContext);
    if (context === undefined) {
        throw new Error("useUserDispatch must be used within a User");
    }
    return context;
}

// ###########################################################

async function loginUser(dispatch,userId, loginValue,userType, authenticateBy, password, history, setIsLoading, setError, setReturnMessage, showMultipleAccounts) {

   
    setError(false);
    setIsLoading(true);
    let attempt_count = JSON.parse(sessionStorage.getItem('login_attempts'));
    let login_attempts_email = sessionStorage.getItem('login_attempts_account_number');
    setError(false);
    setIsLoading(true);
    let loginAttemptCount = 0;
    if (attempt_count && attempt_count > 0 && login_attempts_email != loginValue) {
        sessionStorage.setItem('login_attempts', 0)
    }

    if (!!loginValue && !!password) {
        if (attempt_count == null) {
            sessionStorage.setItem('login_attempts', 1)
            sessionStorage.setItem('login_attempts_account_number', loginValue)
            loginAttemptCount = 1;
        }
        else {
            let count = parseInt(JSON.parse(sessionStorage.getItem('login_attempts')));
            loginAttemptCount = count
        }
        let data = {
            userId: userId,
            loginValue: loginValue,
            Password: password,
            userType:userType,
            LoginAttemptsCount: loginAttemptCount,
            AuthenticateBy: authenticateBy
        };
        var response = null;
        if (authenticateBy === 2) {
            response = await APICall('POST', 'auth/checkIfMultipleAccountExist', data);

        }
        if (response != null && response.success && response.data.length > 1) {
            //if user have multiple account
            showMultipleAccounts(response.data);
            //show multiple user dialog
        } else {
            //if user have single account
            authenticateUser(data, dispatch, loginValue, authenticateBy, password, history, setIsLoading, setError, setReturnMessage, loginAttemptCount);
        }
        //var response = await APICall('POST', 'auth/authenticate', data);
        //if (response.success) {
        //    localStorage.setItem('authenticatedBy', authenticateBy);
        //    setError(null)
        //    setIsLoading(false)
        //    let baseUrl = sessionStorage.getItem('server_api_url');
        //    sessionStorage.clear();
        //    sessionStorage.setItem('server_api_url', baseUrl)
        //    sessionStorage.setItem('auth_token', response.data.authToken)
        //    sessionStorage.setItem('user_info', JSON.stringify(response.data))
        //    sessionStorage.removeItem("login_attempts")

        //    //Call api to get user info
        //    let user_info = JSON.parse(GetUserInfo());
        //    let data = {
        //        userID: user_info.user.customerID
        //    }

        //    var result = await APICall('POST', 'auth/getRoleRights', data);
        //    if (result.success)
        //        sessionStorage.setItem('user_permissions', JSON.stringify(result.data))

        //    //SetMaxFileSize();
        //    //For login
        //    dispatch({ type: 'LOGIN_SUCCESS' });
        //    //For Data
        //    dispatch(setUser(response.data));
        //    history.push('/app/dashboard');
        //}
        //else {
        //    sessionStorage.setItem('login_attempts', parseInt(loginAttemptCount) + 1);
        //    setError(true);
        //    setIsLoading(false);
        //    setReturnMessage(response.message);
        //}

    } else {
        sessionStorage.setItem('login_attempts', parseInt(loginAttemptCount) + 1);
        setError(true);
        setIsLoading(false);
        setReturnMessage(response.message);
    }

}

async function authenticateUser(data, dispatch, accountNumber, authenticateBy, password, history, setIsLoading, setError, setReturnMessage, loginAttemptCount) {
    const setUser = user => ({
        type: 'SET_LOGIN_USER',
        payload: user
    });
    var response = await APICall('POST', 'auth/authenticate', data);
    if (response.success) {
        setError(null)
        setIsLoading(false)
        let baseUrl = sessionStorage.getItem('server_api_url');
        sessionStorage.clear();
        sessionStorage.setItem('server_api_url', baseUrl);
        sessionStorage.setItem('signalRConnectionId', uuidv4());
        sessionStorage.setItem('auth_token', response.data.authToken)
        sessionStorage.setItem('user_info', JSON.stringify(response.data))
        sessionStorage.removeItem("login_attempts")
        sessionStorage.setItem("showPackageExpiryDialog", 1);

        //Call api to get user info
        let user_info = JSON.parse(GetUserInfo());
        let data = {
            userID: user_info.user.userId
        }
        
        var result = await APICall('POST', 'auth/getRoleRights', data);
        if (result.success)
            sessionStorage.setItem('user_permissions', JSON.stringify(result.data))

        //for login tab
        localStorage.setItem('authenticatedBy', authenticateBy);
        //SetMaxFileSize();
        //For login
        dispatch({ type: 'LOGIN_SUCCESS' });
        //For Data
        dispatch(setUser(response.data));
        /*history.push('/app/dashboard');*/
        history.push("/app/" + (result?.data[0]?.landingPage ? result?.data[0]?.landingPage : "dashboard"));
    }
    else {
        sessionStorage.setItem('login_attempts', parseInt(loginAttemptCount) + 1);
        setError(true);
        setIsLoading(false);
        setReturnMessage(response.message);
    }
}

async function forgotPassword(emailaddress, history, setIsLoading, setError, setIsSuccess, setReturnMessage, setResetButtonDisalbed, props) {
    const {showMessage} = props
    setError(false);
    setIsLoading(true);
    if (!!emailaddress) {
        let data = {
            EmailAddress: emailaddress
        };
        setResetButtonDisalbed(true);
        var response = await APICall('POST', 'auth/forgotPassword', data);
        if (response.success) {
            
            localStorage.setItem('forgetPasswordValue', emailaddress);
            setError(null)
            setIsLoading(false)
            setIsSuccess(true)
            setReturnMessage(response.message);
            // successCase( true,response.message);
            showMessage("Success", response.message, "success", 5000);
        }
        else {
            
            setError(true);
            setIsLoading(false);
            setReturnMessage(response.message);
            // successCase(true, response.message);
            // showMessage("Error", response.message, "error", 5000);
        }
    }
    else {
        setError(true);
        setIsLoading(false);
    }
}

async function validateToken(token, setIsAuthToken, setError, setIsValidToken) {
    setError(false)
    setIsAuthToken(true);
    if (!!token) {
        let data = {
            Token: token
        };
        var response = await APICall('POST', 'auth/validateResetToken', data);
        if (response.success) {
            setIsAuthToken(true);
            setIsValidToken(true);
        }
        else {
            setError(true)
            setIsValidToken(false);
            setIsAuthToken(true);
        }

    } else {
        setError(true)
        setIsValidToken(false);
        setIsAuthToken(true);
    }
}

async function resetPassword(dispatch, token, newPassword, confirmPassword, history, setIsLoading, setError, setIsSuccess, setReturnMessage, showSuccessMessage) {

    setError(false);
    setIsLoading(true);
    if (!!token && !!newPassword && !!confirmPassword) {
        if (newPassword == confirmPassword) {
            let data = {
                Token: token,
                Password: newPassword,
                ConfirmPassword: confirmPassword
            };

            var response = await APICall('POST', 'auth/resetPassword', data);
            if (response.success) {
                setError(null)
                setIsLoading(false)
                //showSuccessMessage()
                sessionStorage.setItem('resetPassword', "Successfully");
                history.push('/app/login')
            }
            else {
                setError(true);
                setIsLoading(false);
            }
        }
        else {
            setIsSuccess(false);
            setIsLoading(false);
            setReturnMessage("Passwords can't match")
        }

    } else {
        setIsSuccess(true)
        setIsLoading(false);
    }
}

async function changePassword(dispatch, oldPassword, newPassword, confirmPassword, history, setIsLoading, setError, setIsSuccess, setReturnMessage) {

    let user = sessionStorage.getItem('user_info');

    if (user != null) {
        let userdata = JSON.parse(user).user;
        let email = userdata.emailAddress;

        if (!!email && !!oldPassword && !!newPassword && !!confirmPassword) {

            if (newPassword == confirmPassword) {
                let data = {
                    EmailAddress: email,
                    OldPassword: oldPassword,
                    NewPassword: newPassword,
                    ConfirmPassword: confirmPassword
                };

                var response = await APICall('POST', 'auth/changePassword', data);
                if (response.success) {

                    setError(false);
                    setIsLoading(false);
                    setIsSuccess(true);
                    setReturnMessage(response.message);
                    alert(response.message);
                    history.push('/app/dashboard');
                }
                else {
                    setError(true)
                    setIsLoading(false)
                    setIsSuccess(true)
                    setReturnMessage(response.message);
                }
            }
            else {
                setIsSuccess(false);
                setIsLoading(false);
                setReturnMessage("Passwords can't match")
            }

        } else {
            setError(true)
            setIsLoading(false)
            setIsSuccess(true)
        }
    }
    else {
        setError(true)
        setIsLoading(false)
    }

}

function signOut(dispatch, history) {
    updateLogoutSessionLog();
    localStorage.removeItem("id_token");
    sessionStorage.clear();
    dispatch({ type: "SET_LOGOUT_USER" });
    dispatch({ type: "SIGN_OUT_SUCCESS" });
    history.push("/login");
}
function updateLogoutSessionLog() {

    let user_info = JSON.parse(GetUserInfo());
    let data = {
        userId: user_info.user.userId,
        associateId: user_info.user.associateId
    }
    PostDataAPI("auth/logoutUserSessionLog", data).then((result) => {
        if (result.success) {

        }
    });
}

// ###########################################################

export { UserProvider, useUserState, useUserDispatch, loginUser, forgotPassword, validateToken, resetPassword, changePassword, signOut };